import React from "react";

class Managers extends React.Component {
    render() {
      const styles={
        blackbg: {
          backgroundColor: "#121212"
        },
        blueText:{
          color: "#037ef3"
        }
      }

      return <div className="w-full h-full text-white" style={styles.blackbg}>
            <div className="w-full max-w-2xl m-auto py-8 px-4">
                <div className="text-xl" style={styles.blueText}>AIESEC in SLIIT</div>
                <div className="text-4xl font-bold">People Management - Manager</div>
                <div className="text-xl mt-1 text-gray-400">Application Package</div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Functional Introduction</div>
                  <p className="text-gray-400">We were looking for passionate and committed individuals with a strategically thinking mindset to work as PM Task Force for the term 21/22 of AIESEC in SLIIT. It is with great pleasure that I announce that we found you amazing people to be a part of this function. 
                  <br /><br />
                  Time to go ahead with the second step. <br /><br />
                    Apply to the role that resonates with you the most and help the PM Task Force to be a strong solid team. <br /><br />
                    Good Luck!
                  </p>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Guidelines/Rules</div>
                  <p className="text-gray-400">
                  Applicants can find the job descriptions &amp; KPIs for each position mentioned below. <br />
                  Please read them carefully before you apply and get a proper understanding of the role. <br />
                  <br />
                  Choose what fits best for you.
                  </p>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Timeline</div>
                  <div>
                    <span className="font-bold">Application Open - </span> <span className="text-gray-300">21st May</span> <br/>
                    <span className="font-bold">Application Deadline - </span> <span className="text-gray-300">23rd May</span> <br/>
                    <span className="font-bold">Interviews - </span> <span className="text-gray-300">24th May</span> <br/>
                    <span className="font-bold">Announcement - </span> <span className="text-gray-300">25th May</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">Team Structure</div>
                  <div>
                    <span className="font-bold">HR Manager</span> <span className="text-gray-400">x2</span> <br/>
                    <span className="font-bold">DEVELOP Manager</span> <span className="text-gray-400">x2</span> <br/>
                    <span className="font-bold">Performance Manager</span> <span className="text-gray-400">x2</span> <br/>
                    <span className="font-bold">Education Manager</span> <span className="text-gray-400">x1</span> <br/>
                    <span className="font-bold">Analytics Manager</span> <span className="text-gray-400">x1</span> <br/>
                  </div>
                </div>

                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-1 font-semibold">JDs &amp; KPIs</div>
                  <br/>

                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2" style={{"border": "2px solid #037ef3" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#037ef3" }}>HR Manager <span className="text-gray-500">x2</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Tracking and Reporting of Membership Criteria</li>
                        <li>Updating Inputs and Outputs of Member</li>
                        <li>Building engagement for local and national conferences</li>
                        <li>Tracking and mapping IXP campaigns</li>
                        <li>Onboarding Tracking of New Members</li>
                        <li>Tracking members to events</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Touchpoints with members</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Recruitment</li>
                        <li>Induction</li>
                        <li>Official Expansion Meeting</li>
                        <li>Membership Engagement</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Pre Requirements</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Knowledge of Google Sheets</li>
                        <li>Organization, Attention to detail</li>
                        <li>Recruitment, Selection and Induction (differential) Understanding</li>
                        <li>Good interaction with the membership</li>
                      </ul>
                    </div>
                  </div>
                
                  {/*  =====================================================  */}
                  <div className="w-full rounded-lg border p-2 mt-4" style={{"border": "2px solid #F85A40" }}>
                    <div className="text-center text-2xl font-bold"style={{"color": "#F85A40" }}>DEVELOP Manager <span className="text-gray-500">x2</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Support and tracking of functional induction</li>
                        <li>Follow-up and support for Local Educational Cycle (LEC) implementation</li>
                        <li>Response Engagement in the Global and National Membership Survey</li>
                        <li>Monitor and ensure the continuity of PDP</li>
                        <li>Compile members' PDPs and set action plans to ensure compliance with them</li>
                        <li>Tracking and Reporting of Team Standards to the Edu. Manager</li>
                        <li>Building member engagement strategies</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Touchpoints with members</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data Management</li>
                        <li>Understanding the KPIs and MoS of each area</li>
                        <li>Membership Engagement</li>
                        <li>Effective Communication</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Pre Requirements</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data driven analysis</li>
                        <li>Organization, Attention to detail</li>
                        <li>Understanding Operations</li>
                        <li>Creativity</li>
                      </ul>
                    </div>
                  </div>
                
                   {/*  =====================================================  */}
                   <div className="w-full rounded-lg border p-2 mt-4" style={{"border": "2px solid #FFC845" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#FFC845" }}>Performance Manager <span className="text-gray-500">x2</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Updating the Incentive Systems</li>
                        <li>Follow Up on members added to EXPA</li>
                        <li>Monitor and ensure the continuity of PDP</li>
                        <li>Compile members' PDPs and set action plans to ensure compliance with them</li>
                        <li>Build and run Calibration Meetings with Team Leaders after the PDP Setting</li>
                        <li>Building Members engagement strategies </li>

                      </ul>
                    </div> <br/>

                    <div className="font-bold">Touchpoints with members</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data Management</li>
                        <li>Arrangement with Official Expansion Meetings</li>
                        <li>Understanding the KPIs and MoS of each area</li>
                        <li>Membership Engagement</li>
                        <li>Effective Communication</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Pre Requirements</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data driven analysis</li>
                        <li>Organization, Attention to detail</li>
                        <li>Understanding Operations</li>
                        <li>Creativity</li>
                      </ul>
                    </div>
                  </div>
                
                 {/*  =====================================================  */}
                 <div className="w-full rounded-lg border p-2 mt-4" style={{"border": "2px solid #F48924" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#F48924" }}>Education Manager <span className="text-gray-500">x1</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                      <li>Support in functional induction</li>
                      <li>AIE Knowledge to be shared during OEMs and other necessary trainings </li>
                      <li>Follow-up and support for LEC implementation</li>
                      <li>Response Engagement in the National Membership Survey</li>
                      <li>Team Standards Report at LB Meeting</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Touchpoints with members</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                      <li>Data Management</li>
                      <li>Understanding the KPIs and MoS of each area</li>
                      <li>Membership Engagement</li>
                      <li>Effective Communication</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Pre Requirements</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data driven analysis</li>
                        <li>Organization, Attention to detail</li>
                        <li>Understanding Operations</li>
                        <li>Creativity</li>
                      </ul>
                    </div>
                  </div>
                
                {/*  =====================================================  */}
                <div className="w-full rounded-lg border p-2 mt-4" style={{"border": "2px solid #0CB9C1" }}>
                    <div className="text-center text-2xl font-bold" style={{"color": "#0CB9C1" }}>Analytics Manager <span className="text-gray-500">x1</span></div>

                    <div className="font-bold">Job Description</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Updating the Incentive Systems</li>
                        <li>Follow Up on members added to EXPA</li>
                        <li>Tracking and Reporting of Membership Criteria</li>
                        <li>Onboarding Tracking of New Members</li>
                        <li>Prepare and maintain Member Data storage means.</li>
                        <li>Track and create Member Insights.</li>
                        <li>Ensure the effective use of People Analytics in the entity.</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Touchpoints with members</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data Management</li>
                        <li>Data Analysis</li>
                        <li>Understanding the KPIs and MoS of each area</li>
                        <li>Membership Engagement</li>
                        <li>Effective Communication</li>
                      </ul>
                    </div> <br/>

                    <div className="font-bold">Pre Requirements</div>
                    <div className="text-gray-400">
                      <ul className="list-inside list-disc">
                        <li>Data driven analysis</li>
                        <li>Knowledge of Google Sheets</li>
                        <li>Knowledge of other Data tools</li>
                        <li>Organization, Attention to detail</li>
                        <li>Understanding Operations</li>
                        <li>Good interaction with the membership</li>
                      </ul>
                    </div>
                  </div>


                <div className="mt-8">
                  <div className="w-full h-1 bg-gray-700 mb-8"></div>
                  <div className="text-2xl mb-4 font-semibold">Contact Info</div>
                  <div>
                    <div >For any clarifications, </div> 
                    <div style={styles.blueText} className="text-3xl">Odhara Kodikara </div> 
                    <div className="text-gray-400">Vice President People Management – AIESEC in SLIIT</div>
                    <div className="text-gray-400">odhara.kodikara@aiesec.net</div>
                    <div className="text-gray-400">0705283450</div>
                    
                  </div>
                </div>

                <a href="https://forms.gle/Vp6879Xe5LwfbPWm9" target="_blank" rel="noreferrer">
                <div className="my-8 rounded-md w-full h-10 text-center text-lg font-bold grid content-center cursor-pointer" style={{"background": "#037ef3"}}>
                  Apply
                </div>
                </a>

                </div>
            </div>
      </div>;
    }
  }

export default Managers